export default "__VITE_ASSET__DagbEieP__"